export default "__VITE_ASSET__Okrti$yGHifxLXOXbkyUwg__"